import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-ink text-bone" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-6 sm:px-8 lg:px-10 py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="font-display text-2xl mb-3">Health and More</div>
            <p className="text-sm text-sage max-w-xs leading-relaxed">
              We connect independent practices to hospital-system programs in 340B pharmacy, remote
              patient monitoring, and administrative services.
            </p>
          </div>
          <div>
            <div className="tabular text-xs uppercase tracking-[0.18em] text-sage mb-4">Programs</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/340b" className="hover:text-brass transition-colors" data-testid="footer-340b">340B pharmacy</Link></li>
              <li><Link to="/rpm" className="hover:text-brass transition-colors" data-testid="footer-rpm">Remote patient monitoring</Link></li>
              <li><Link to="/mso" className="hover:text-brass transition-colors" data-testid="footer-mso">Administrative services</Link></li>
              <li><Link to="/network" className="hover:text-brass transition-colors" data-testid="footer-network">Network</Link></li>
            </ul>
          </div>
          <div>
            <div className="tabular text-xs uppercase tracking-[0.18em] text-sage mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/how-it-works" className="hover:text-brass transition-colors" data-testid="footer-how">How it works</Link></li>
              <li><Link to="/about" className="hover:text-brass transition-colors" data-testid="footer-about">About</Link></li>
              <li><Link to="/contact" className="hover:text-brass transition-colors" data-testid="footer-contact">Contact</Link></li>
              <li><Link to="/privacy" className="hover:text-brass transition-colors" data-testid="footer-privacy">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-brass transition-colors" data-testid="footer-terms">Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-sage/25 flex flex-col sm:flex-row justify-between gap-3 text-xs text-sage">
          <span>© {new Date().getFullYear()} Health and More. healthandmore.net</span>
          <span>340B eligibility is held by our covered-entity hospital partners, not by private practices.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
